export default __webpack_public_path__ + "static/media/calendarKomision.5fbfa3b1.svg";